import { FILTERS, FilterWidget } from '@sorare/core/src/lib/filters';
import { NBATeams } from '@sorare/core/src/lib/nbaTeams';

import buildRefineTeam from '@sorare/us-sports/src/components/searchCards/buildRefineTeam';

export default ({
  keepNoResults = true,
}: {
  keepNoResults?: boolean;
} = {}): FilterWidget =>
  buildRefineTeam(FILTERS.activeTeam, NBATeams, keepNoResults);
